import { useEffect } from "react";
import Lenis from "lenis";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import "@/App.css";
import { Header } from "@/components/Header";
import { Hero } from "@/components/Hero";
import { TradeMarquee } from "@/components/TradeMarquee";
import { Sequence } from "@/components/Sequence";
import { WhatChanges } from "@/components/WhatChanges";
import { Pricing } from "@/components/Pricing";
import { Trades } from "@/components/Trades";
import { Faq } from "@/components/Faq";
import { ClosingCta } from "@/components/ClosingCta";
import { Footer } from "@/components/Footer";
import { StickyCallBar } from "@/components/StickyCallBar";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";

const Home = () => (
  <div id="top" className="bg-asphalt font-body text-white pb-16 sm:pb-0">
    <Header />
    <main>
      <Hero />
      <TradeMarquee />
      <Sequence />
      <WhatChanges />
      <Pricing />
      <Trades />
      <Faq />
      <ClosingCta />
    </main>
    <Footer />
    <StickyCallBar />
  </div>
);

const ScrollManager = () => {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const el = document.querySelector(hash);
      if (el) {
        el.scrollIntoView();
        return;
      }
    }
    window.scrollTo(0, 0);
  }, [pathname, hash]);
  return null;
};

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, anchors: true });
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <BrowserRouter>
      <ScrollManager />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/terms" element={<Terms />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
